const useLocalStorage = {
  getItem: (key: string) => {
    const data: any = localStorage.getItem(key);
    try {
      return JSON.parse(data);
    } catch (e) {
      return data;
    }
    // return data ? JSON.parse(data) : null;
  },
  setItem: (key: string, value: any) => {
    if (key === "loginData") {
      //clear the storage key and set again to avoid any old data issues
      localStorage.removeItem(key);
      const originalDateTimeFormat =
        value?.original_datetime_format || value?.datetime_format;
      let trimmedDateTimeFormat = originalDateTimeFormat?.includes(",")
        ? originalDateTimeFormat.split(",")[0]
        : originalDateTimeFormat;
      value = {
        ...value,
        original_datetime_format: originalDateTimeFormat,
        datetime_format: trimmedDateTimeFormat?.trim(),
      };
    }
    return localStorage.setItem(key, JSON.stringify(value));
  },
  removeItem: (key: string) => {
    return localStorage.removeItem(key);
  },
  clear: () => {
    return localStorage.clear();
  },
  key: (index: number) => {
    return localStorage.key(index);
  },
};

export default useLocalStorage;
